import type { PropsWithChildren } from "react";
import React from "react";
import { HeartFilledIcon, HeartOutlineIcon } from "components/SvgIcons";
import * as styles from "./WishlistButton.css";
import { colours } from "@shared/ui.design-system";

interface WishlistButtonProps extends PropsWithChildren {
  onClick: () => void;
  active: boolean;
}

export const WishlistButton: React.FC<WishlistButtonProps> = ({
  children,
  onClick,
  active
}) => {
  const handleToggleWishlist = (event) => {
    event.preventDefault();
    onClick();
  };
  return (
    <div className={styles.container}>
      {children}
      <div
        role="button"
        tabIndex={0}
        className={styles.button}
        onClick={handleToggleWishlist}
        onKeyDown={handleToggleWishlist}
        data-testid="wishlist-button"
        aria-label={active ? "Remove from wishlist" : "Add to wishlist"}
      >
        {active ? (
          <HeartFilledIcon
            data-testid="heart-filled-icon"
            color={colours.accent.strong}
            backgroundColor={colours.secondary.warm}
            display="block"
            boxSize={{ base: "1.5rem" }}
          />
        ) : (
          <HeartOutlineIcon
            data-testid="heart-outline-icon"
            color={colours.primary.dark}
            backgroundColor={colours.secondary.warm}
            display="block"
            boxSize={{ base: "1.5rem" }}
          />
        )}
      </div>
    </div>
  );
};
